import type { IFilter } from '@models/Filter'

import { apiClient } from '../../gateways/api'
import type { GebiedswisselsSearch } from '../types/GebiedswisselsSearch'

export { searchGebiedswissels, initialState, createFilters }

const searchGebiedswissels = async ({
  query,
}: {
  query: GebiedswisselsSearch['query']
}): Promise<GebiedswisselsSearch['data']> => {
  const { filters, page } = query

  const { data } = await apiClient({
    url: '/rest/beheer/gebiedswissel/search',
    method: 'POST',
    data: { filters: createFilters(filters), ...page },
  })

  return data
}

const initialState: GebiedswisselsSearch = {
  data: { count: 0, skip: 0, limit: 25, items: [] },
  query: {
    filters: { gebied: [], status: null },
    page: { skip: 0, limit: 25 },
  },
}

const createFilters = ({ gebied, status }) => {
  const filters: IFilter[] = []

  if (gebied && gebied.length > 0)
    filters.push({
      name: 'gebiedscode',
      value: gebied.map(({ code }) => code),
      operator: 'in',
    })
  if (status)
    filters.push({ name: 'status', value: status.code, operator: 'eq' })

  return filters
}
